import { ISvgProps, Svg } from '@components';
import { memo } from 'react';

export const CircleIcon = memo<ISvgProps>((props, { className }) => (
  <Svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M12 24.1777C18.6274 24.1777 24 18.8052 24 12.1777C24 5.55032 18.6274 0.177734 12 0.177734C5.37258 0.177734 0 5.55032 0 12.1777C0 18.8052 5.37258 24.1777 12 24.1777Z"
      fill="#3477EB"
    />
    <path
      d="M7 12.5111L10.3333 15.8444L17 9.17773"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
));

CircleIcon.displayName = 'CircleIcon';

export default CircleIcon;
